import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import ColorButton from "../common/ColorButton";
import { BLUE_COLOR, Green_COLOR } from "../../constance/color";
import { ArrowRightOutlined } from "@ant-design/icons";
import { Button, Space } from "antd";


export default function OvenSetMenu(props) {
  const {
    onGoToSelectOvenSet,
    onGoToSelectOvenSetDetail,
    onBack,
  } = props;

  const { t } = useTranslation();

  return (
    <div style={{ marginTop: '3rem' }}>
      <Space direction="vertical" size={'large'}>
        <Space direction="vertical">
          <ColorButton
            type='primary'
            override={BLUE_COLOR}
            icon={<ArrowRightOutlined />}
            iconPosition='end'
            onClick={onGoToSelectOvenSet}>
            {t('post_baking_waste_wood_count.select_oven_set')}
          </ColorButton>

          <ColorButton
            type='primary'
            override={Green_COLOR}
            icon={<ArrowRightOutlined />}
            iconPosition='end'
            onClick={onGoToSelectOvenSetDetail} >
            {t('post_baking_waste_wood_count.oven_set_wood_status')}
          </ColorButton>
        </Space>

        <Button variant="filled" color="default" onClick={onBack} >{t('back')}</Button>
      </Space>
    </div>
  )
}


OvenSetMenu.propTypes = {
  onGoToSelectOvenSet: PropTypes.func,
  onGoToSelectOvenSetDetail: PropTypes.func,
  onBack: PropTypes.func,
}

OvenSetMenu.defaultProps = {
  onGoToSelectOvenSet: () => null,
  onGoToSelectOvenSetDetail: () => null,
  onBack: () => null,
}